<template>
  <navbar>
    <button class="navbar-toggler mobile-sidebar-toggler hidden-lg-up" type="button" @click="mobileSidebarToggle">&#9776;</button>
    <a class="navbar-brand" href="#"></a>
    <ul class="nav navbar-nav hidden-md-down">
      <li class="nav-item">
        <a class="nav-link navbar-toggler sidebar-toggler" href="#" @click="sidebarToggle">&#9776;</a>
      </li>
    </ul>

    <ul class="nav navbar-nav">
      <search/>
    </ul>

    <ul class="nav navbar-nav ml-auto">
      <dropdown size="nav" class="nav-item">
        <span slot="button">
          <v-gravatar v-bind:email="user.email" class="img-avatar" v-bind:alt="user.email"/>
          <span class="hidden-md-down">{{user.email}}</span>
        </span>
        <div slot="dropdown-menu"class="dropdown-menu dropdown-menu-right">
          <a class="dropdown-item" href="#" v-on:click.prevent="logout"><i class="fa fa-lock"></i> Logout</a>
        </div>
      </dropdown>
      <li class="nav-item hidden-md-down">
        <a class="nav-link navbar-toggler aside-menu-toggler" href="#" @click="asideToggle">&#9776;</a>
      </li>
    </ul>
  </navbar>
</template>
<script>

import navbar from './Navbar'
import { dropdown } from 'vue-strap'
import authentication from 'services/authentication'
import search from 'components/Search'
import Vue from 'vue'
import Gravatar from 'vue-gravatar'
Vue.component('v-gravatar', Gravatar)

export default {
  name: 'header',
  components: {
    navbar,
    dropdown,
    search
  },
  methods: {
    logout () {
      authentication.logout()
    },
    click () {
      // do nothing
    },
    sidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-hidden')
    },
    mobileSidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-mobile-show')
    },
    asideToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('aside-menu-hidden')
    }
  },
  computed: {
    user () {
      return authentication.user()
    }
  }
}
</script>

<style lang="css">

.dropdown-toggle::after {
  /*display: none !important;*/
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue